import {
  MQ_MIN_LARGE,
  MQ_MIN_MEDIUM,
  MQ_MIN_SMALL,
  MQ_MIN_X_LARGE,
} from '@app/theme/types';
import { labelStyles } from '../Input/styles';

interface ILabel {
  mb?: 'flex' | 'none';
  sm?: 'flex' | 'none';
  md?: 'flex' | 'none';
  lg?: 'flex' | 'none';
  xl?: 'flex' | 'none';
  title?: string;
}
const Label = ({ mb, sm, md, lg, xl, title = '' }: ILabel) => {
  return (
    <label
      css={[
        labelStyles,
        {
          display: `${mb || 'flex'}`,
          [MQ_MIN_SMALL]: {
            display: `${sm || mb || 'flex'}`,
          },
          [MQ_MIN_MEDIUM]: {
            display: `${md || sm || mb || 'flex'}`,
          },
          [MQ_MIN_LARGE]: {
            display: `${lg || md || sm || mb || 'flex'}`,
          },
          [MQ_MIN_X_LARGE]: {
            display: `${xl || lg || md || sm || mb || 'flex'}`,
          },
        },
      ]}>
      {title || <br />}
    </label>
  );
};

export default Label;
